import { BugTracker } from "../../library";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorType } from "../../types";
import React from "react";
import SError from "./SError";
import { getError } from "../../utils";

type ErrorFallbackArguments = {
  error: Error;
  resetErrorBoundary: () => void;
};

const ErrorFallback = ({
  error,
  resetErrorBoundary,
}: ErrorFallbackArguments) => {
  const { message, type } = getError(error);
  return (
    <SError
      title="Whoops!"
      subtitle={`Something went wrong. Please check your network or reload the page.`}
      description={message}
      resetErrorBoundary={resetErrorBoundary}
      type={type ? type : ErrorType.HANDLED}
    />
  );
};

interface IProps {
  children: JSX.Element;
}

const ErrorHandler = (error: Error, info: { componentStack: string }) => {
  // Do something with the error
  // E.g. log to an error logging client here
  BugTracker.captureException(error);
  console.log("ERROR:", error.message);
  console.log(info.componentStack);
};

const SErrorBoundary: React.FC<IProps> = ({ children }) => {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
      onError={ErrorHandler}
    >
      {children}
    </ErrorBoundary>
  );
};

export default SErrorBoundary;
